package com.binayshaw7777.kotfolio.components.model

data class WorkExperience(
    val sequenceNumber: String,
    val role: String,
    val organization: String,
    val duration: String
)